
import { Box, Skeleton} from '@mui/material';

function RecommendationsSkeleton() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "60vh",
      }}
    >
      <Box sx={{ textAlign: "center", width: "100%" }}>
        {/* Title skeleton */}
        <Skeleton
          variant="text"
          width="40%"
          height={40}
          sx={{
            mx: 'auto',
            mb: 4,
            bgcolor: 'grey.300',
          }}
        />
        
        {/* Description skeletons */}
        <Skeleton
          variant="text"
          width="90%"
          height={24}
          sx={{
            mx: 'auto',
            mb: 2,
            bgcolor: 'grey.300',
          }}
        />
        <Skeleton
          variant="text"
          width="95%"
          height={24}
          sx={{
            mx: 'auto',
            mb: 2,
            bgcolor: 'grey.300',
          }}
        />
        <Skeleton
          variant="text"
          width="85%"
          height={24}
          sx={{
            mx: 'auto',
            mb: 2,
            bgcolor: 'grey.300',
          }}
        />
        <Skeleton
          variant="text"
          width="92%"
          height={24}
          sx={{
            mx: 'auto',
            mb: 2,
            bgcolor: 'grey.300',
          }}
        />
        <Skeleton
          variant="text"
          width="80%"
          height={24}
          sx={{
            mx: 'auto',
            bgcolor: 'grey.300',
          }}
        />
      </Box>
    </Box>
  );
}

export default RecommendationsSkeleton;